export { COOKIE_NAME, ONE_YEAR_MS } from "@shared/const";

/**
 * Admin sign-in, under Cloudflare Access.
 *
 * There is no login URL to construct any more. Under Manus this function built
 * an OAuth authorize URL, minted a CSRF nonce and planted a state cookie before
 * navigating to manus.im.
 *
 * Cloudflare Access works at the network edge instead: a request to a protected
 * path is intercepted *before* it reaches this application, and Cloudflare
 * serves its own login page. So "start login" is simply "navigate to a
 * protected path" — Access takes over from there, and once the user has
 * authenticated it forwards them on to the page they originally asked for.
 *
 * This also means the CSRF nonce machinery is gone, and with it a class of bug:
 * the old flow could desync its cookie from the in-flight `state` and reject a
 * legitimate login with "invalid oauth state".
 */
const ADMIN_ENTRY_PATH = "/operations";

export const startLogin = () => {
  if (typeof window === "undefined") return;

  // Reloading the current page here used to seem sensible — bounce the request
  // back through the edge and let Access challenge it. It is actually an
  // infinite loop: if Access is not enforcing on this path, or the app cannot
  // read the identity it forwards, the reload lands in the identical state and
  // the button appears to do nothing while the page flickers.
  //
  // So: only navigate when that navigation can change something. Already on a
  // protected path and still unauthenticated means the problem is upstream —
  // in the Access configuration, not in the browser — and no amount of
  // reloading will fix it.
  if (window.location.pathname.startsWith(ADMIN_ENTRY_PATH)) return;

  window.location.href = ADMIN_ENTRY_PATH;
};

/**
 * Cloudflare Access serves this endpoint on every hostname it protects, so no
 * team domain needs to be configured in the client. Hitting it clears the
 * Access session, which is the part that actually matters — clearing only
 * application state would leave the user silently signed in at the edge.
 */
export const ACCESS_LOGOUT_PATH = "/cdn-cgi/access/logout";
